export const identityVerificationURLs = {
  // request verification
  request: (userId: number): string  => `/v4/users/${userId}/verify/request`,
  // check verification status
  status: (userId: number): string  => `/v3/users/${userId}/verify/status`,
  // get available verification method parameters
  method: (userId: number): string  => `/v1/users/${userId}/verify/method`,
  // get available verification method + access token for auto method
  init: (userId: number): string => `/v1/users/${userId}/verify/init`,
  // update user's birthdate
  updateBirthDate: (): string => '/v1/verify/user'
};
